import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../../app/store'
import { getSJWHToken } from '../../../services/delivery'

//单位类别

export const unitCategoryList = [
  {
    value: 1,
    label: "医院",
    // children: [
    //   {
    //     value: 101,
    //     label: "综合医院",
    //   },
    //   {
    //     value: 102,
    //     label: "中医医院",
    //   },
    //   {
    //     value: 103,
    //     label: "中西医结合医院",
    //   },
    //   {
    //     value: 104,
    //     label: "民族医医院",
    //   },
    //   {
    //     value: 105,
    //     label: "专科医院",
    //   },
    //   {
    //     value: 106,
    //     label: "康复医院",
    //   },
    // ],
  },
  {
    value: 2,
    label: "妇幼保健院",
    // children: [
    //   {
    //     value: 201,
    //     label: "妇幼保健院",
    //   },
    //   {
    //     value: 202,
    //     label: "妇幼保健计划生育服务中心",
    //   },
    // ],
  },
  {
    value: 3,
    label: "社区卫生服务机构",
    // children: [
    //   {
    //     value: 301,
    //     label: "社区卫生服务中心",
    //   },
    //   {
    //     value: 302,
    //     label: "社区卫生服务站",
    //   },
    // ],
  },
  {
    value: 4,
    label: "卫生院",
    // children: [
    //   {
    //     value: 401,
    //     label: "中心卫生院",
    //   },
    //   {
    //     value: 402,
    //     label: "乡（镇）卫生院",
    //   },
    //   {
    //     value: 403,
    //     label: "街道卫生院",
    //   },
    // ],
  },
  {
    value: 5,
    label: "疗养院",
    // children: [
    //   {
    //     value: 501,
    //     label: "疗养院",
    //   },
    // ],
  },
  {
    value: 6,
    label: "门诊部",
    // children: [
    //   {
    //     value: 601,
    //     label: "综合门诊部",
    //   },
    //   {
    //     value: 602,
    //     label: "专科门诊部",
    //   },
    //   {
    //     value: 603,
    //     label: "中医门诊部",
    //   },
    //   {
    //     value: 604,
    //     label: "中西医结合门诊部",
    //   },
    //   {
    //     value: 605,
    //     label: "民族医门诊部",
    //   },
    // ],
  },
  {
    value: 7,
    label: "诊所",
    // children: [
    //   {
    //     value: 701,
    //     label: "诊所",
    //   },
    //   {
    //     value: 702,
    //     label: "中医诊所",
    //   },
    //   {
    //     value: 703,
    //     label: "民族医诊所",
    //   },
    //   {
    //     value: 704,
    //     label: "卫生所",
    //   },
    //   {
    //     value: 705,
    //     label: "医务室",
    //   },
    //   {
    //     value: 706,
    //     label: "卫生保健所",
    //   },
    //   {
    //     value: 707,
    //     label: "卫生站",
    //   },
    // ],
  },
  {
    value: 8,
    label: "村卫生室",
    // children: [
    //   {
    //     value: 801,
    //     label: "村卫生室（所）",
    //   },
    // ],
  },
  {
    value: 9,
    label: "急救中心（站）",
    // children: [
    //   {
    //     value: 901,
    //     label: "急救中心",
    //   },
    //   {
    //     value: 902,
    //     label: "急救站",
    //   },
    // ],
  },
  {
    value: 10,
    label: "临床检验中心",
    // children: [
    //   {
    //     value: 1001,
    //     label: "临床检验中心",
    //   },
    // ],
  },
  {
    value: 11,
    label: "专科疾病防治机构",
    // children: [
    //   {
    //     value: 1101,
    //     label: "专科疾病防治院",
    //   },
    //   {
    //     value: 1102,
    //     label: "专科疾病防治所",
    //   },
    //   {
    //     value: 1103,
    //     label: "专科疾病防治站",
    //   },
    // ],
  },
  {
    value: 12,
    label: "护理院（站）",
    // children: [
    //   {
    //     value: 1201,
    //     label: "护理院",
    //   },
    //   {
    //     value: 1202,
    //     label: "护理站",
    //   },
    // ],
  },
  {
    value: 13,
    label: "中心（实验室）",
    // children: [
    //   {
    //     value: 1301,
    //     label: "医学检验实验室",
    //   },
    //   {
    //     value: 1302,
    //     label: "病理诊断中心",
    //   },
    //   {
    //     value: 1303,
    //     label: "医学影像诊断中心",
    //   },
    //   {
    //     value: 1304,
    //     label: "血液透析中心",
    //   },
    //   {
    //     value: 1305,
    //     label: "安宁疗护中心",
    //   },
    //   {
    //     value: 1306,
    //     label: "医疗消毒共用中心",
    //   },
    //   {
    //     value: 1307,
    //     label: "康复医疗中心",
    //   },
    //   {
    //     value: 1308,
    //     label: "护理中心",
    //   },
    //   {
    //     value: 1309,
    //     label: "健康体检中心",
    //   },
    // ],
  },
  {
    value: 14,
    label: "其他",
    // children: [
    //   {
    //     value: 1401,
    //     label: "其他",
    //   },
    // ],
  },
]

//营业状态
export const getOperateStatusName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "正常营业"
    case 1:
      return "关闭"
    case 2:
      return "暂停营业"
    case 3:
      return "注销"
    default:
      return "-"
  }
}

//医院级别
export const getInstitutionalLevelName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "一级"
    case 1:
      return "二级"
    case 2:
      return "三级"
    case 3:
      return "未定级"
    case 4:
      return "无级别"
    default:
      return "-"
  }
}

//经营性质
export const getOperateTypeName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "营利性"
    case 1:
      return "非营利性（政府办）"
    case 2:
      return "非营利性（非政府办）"
    case 3:
      return "未定非营利性级"
    default:
      return "-"
  }
}

//所有制形式
export const getOwnershipTypeName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "私有"
    case 1:
      return "集体"
    case 2:
      return "股份制"
    case 3:
      return "全民"
    case 4:
      return "合伙制"
    case 5:
      return "股份合作制"
    case 6:
      return "中外合资合作"
    case 7:
      return "国有"
    case 8:
      return "其他"
    default:
      return "-"
  }
}

//抗菌药品静脉输注权限
export const getAntibacterialStateName = (status: number) => {
  switch (Number(status)) {
    case 0:
      return "无权限"
    case 1:
      return "有权限"
    default:
      return "-"
  }
}

//服务方式
export const getServiceName = (status: number) => {
  switch (status) {
    case 0:
      return "巡诊服务"
    case 1:
      return "家庭服务"
    case 2:
      return "住院服务"
    case 3:
      return "急诊服务"
    case 4:
      return "门诊服务"
    case 5:
      return "其他服务"
    default:
      return ""
  }
}

//上报类型
export const getAskTypeName = (status: number) => {
  switch (Number(status)) {
    case 1:
      return "机构信息调整"
    case 2:
      return "机构上报"
    case 3:
      return "医生信息调整"
    case 4:
      return "医生上报"
    default:
      return "-"
  }
}

//获取单位类别
export const getChildItem = (value: number) => {
  return unitCategoryList.find((child) => child.value === Number(value))?.label
}


// key
export const getKey = (word: string) => {
  switch (word) {
      case 'name':
          return '机构名称'
      case 'secondName':
          return '机构第二名称'
      case 'uniCode':
          return '社会统一信用代码'
      case 'operateStatus':
          return '营业状态'
      case 'institutionalLevel':
          return '医院级别'
      case 'unitCategory':
          return '单位类别'
      case 'operateType':
          return '经营性质'
      case 'ownershipType':
          return '所有制形式'
      case 'effectStartDate':
          return '有效开始日期'
      case 'effectEndDate':
          return '有效结束日期'
      case 'nextCheckTime':
          return '下一个校验日期'
      case 'bedAmount':
          return '床位数'
      case 'dentalChairAmount':
          return '牙科诊椅数'
      case 'legalRepresentative':
          return '法定代表人'
      case 'corporationNumber':
          return '法人证件号'
      case 'chargePerson':
          return '主要负责人'
      case 'chargePersonNumber':
          return '负责人证件号'
      case 'regioncode':
          return '行政区划名称'
      case 'address':
          return '医疗机构地址'
      case 'diagnosisSubject':
          return '诊疗科目名称'
      case 'antibacterialState':
          return '抗菌药品静脉输注权限'
      case 'phone':
          return '电话'
      case 'licenceIssuingAuthority':
          return '发证机关'
      case 'approvalNumber':
          return '批准文号'
      case 'registeredCapital':
          return '注册资金'
      case 'service':
          return '服务方式'
      case 'postalCode':
          return '邮编'
      default:
          return '-'
  }
}

export const hasValue = (value: any) => {
  return value !== undefined && value !== null && value !== '';
}

export const getSJWHTokenAsync = createAsyncThunk<
  void,
  void,
  RootThunkApi<void>
>('delivery/getSJWHTokenAsync', async (_, api) => {
  return sendAsync(getSJWHToken(), api)
})